import React, { useEffect, useState } from "react";
import BankStatementView from "app/components/imagesUploads/joint/BankStatementView";
import ViewFilesModel from "app/components/common/ViewFilesModel";
import { useLocation } from "react-router-dom";
interface FileUploadProps {
  label: string;
  description: string;
  name: string;
  disabled?: boolean;
  register: any;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
  icon?: React.ReactNode;
  required?: boolean;
  acceptedTypes?: string[];
  multiple?: boolean;
  uploadedFiles?: any;
  handleDeleteImage: (index: number) => void;
  hasSavedFiles: boolean;
}

const UploadNewBankStatement: React.FC<FileUploadProps> = ({
  label,
  description,
  name,
  disabled = false,
  register,
  onChange,
  inputRef,
  icon,
  required = true,
  acceptedTypes = ["image/jpeg", "image/png", "application/pdf"],
  multiple = true,
  uploadedFiles,
  handleDeleteImage,
  hasSavedFiles = false,
}) => {
  const location = useLocation();
  const isJointApplicant = location.pathname === "/joint-assets-liabilities";
  const boxHeight = isJointApplicant
    ? "xl:h-[205px] h-[205px]"
    : "xl:h-[220px] h-[220px]";

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const uploadedFilesArray = uploadedFiles && Array.from(uploadedFiles);

  useEffect(() => {
    if (uploadedFilesArray?.length <= 2) {
      setIsModalOpen(false);
    }
  }, [uploadedFilesArray]);

  return (
    <>
      <div
        className={`bg-[#EAECF0] py-7 w-full text-center  relative rounded-[20px] ${
          hasSavedFiles ? boxHeight : "xl:h-[340px] h-[340px]"
        }  flex flex-col items-center`}
      >
        <div className="text-center">{icon}</div>

        <h6 className="text-[14px] font-Mulish font-normal text-darkgrey mb-3 mt-4">
          {label}
        </h6>
        {!hasSavedFiles && (
          <>
            <p className="text-[12px] font-Mulish font-normal text-[#313131] w-full sm:w-[80%] mx-auto mb-2">
              Prefer not to connect your bank? You can upload a recent bank
              statement instead. 
            </p>
            <button
              onClick={() =>
                window.open(
                  "https://hejaz-lending.s3.ap-southeast-2.amazonaws.com/web-assets/Hejaz+Auto+Finance-+Documents+Checklist.pdf",
                  "_blank"
                )
              }
              type="button"
              className="text-center text-[12px] font-Mulish text-primary font-semibold mb-3 cursor-pointer"
            >
              View document checklist
            </button>
            <p className="text-[12px] font-Mulish font-normal text-[#313131] w-full sm:w-[80%] mx-auto mb-5">
              If the statement has multiple sides, please upload all relevant
              pages.
            </p>
          </>
        )}

        <p
          className={`text-[12px] font-Mulish font-normal text-[#98A2B3] w-full sm:w-[80%] mx-auto ${
            hasSavedFiles ? "mb-5" : "mb-9"
          } `}
        >
          {description}
        </p>

        <div className="m-auto">
          <input
            type="file"
            accept={acceptedTypes.join(",")}
            multiple={true}
            {...register(name, {
              required: required ? "Files are required" : false,
            })}
            onChange={onChange}
            ref={inputRef}
            hidden
          />

          <button
            type="button"
            onClick={() => inputRef?.current?.click()}
            disabled={disabled}
            className={`absolute bottom-6 md:bottom-5   translate-x-[-50%] border border-solid border-[#ccc] text-sm font-normal text-[#585C7B] font-Mulish text-[14px] rounded-full px-4 py-2 ${
              disabled ? "cursor-not-allowed opacity-70" : "cursor-pointer"
            }`}
          >
            Choose file{multiple ? "s" : ""}
          </button>
        </div>
      </div>

      {uploadedFilesArray?.length > 0 && (
        <>
          {uploadedFilesArray?.slice(0, 2).map((file: File, index: number) => {
            const FileName = file instanceof File ? file.name : file;
            return (
              <>
                <BankStatementView
                  key={index}
                  fileName={FileName}
                  onDelete={() => handleDeleteImage(index)}
                />
              </>
            );
          })}

          {uploadedFilesArray?.length > 2 && (
            <h6
              className="text-right text-[12px] cursor-pointer text-[#1F314E] font-Mulish font-normal"
              onClick={() => setIsModalOpen(true)}
            >
              {uploadedFiles.length - 2} more file
              {uploadedFiles.length - 2 > 1 ? "s" : ""} Uploaded
            </h6>
          )}
        </>
      )}
      <ViewFilesModel
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        uploadedFilesArray={uploadedFilesArray}
        handleDeleteImage={handleDeleteImage}
      />
    </>
  );
};

export default UploadNewBankStatement;
